// Centralized route configuration
export const ROUTES = {
  LANDING: '/',
  BOUNTY: '/:tokenId',
  NEW_BOUNTY: '/new',
  NOT_FOUND: '/404',
}; 